
import React from 'react';
import { FastingProtocol } from '@/types/fasting';
import { Progress } from '@/components/ui/progress';
import { Clock } from 'lucide-react';

interface FastingStagesProps {
  elapsed: number;
  protocol: FastingProtocol;
}

export const FastingStages: React.FC<FastingStagesProps> = ({ elapsed, protocol }) => {
  const currentMilestone = protocol.milestones
    .filter(milestone => milestone.hour <= elapsed)
    .pop();

  const nextMilestone = protocol.milestones
    .find(milestone => milestone.hour > elapsed);
    
  // Calculate progress to next milestone
  const progressToNext = nextMilestone 
    ? ((elapsed - (currentMilestone?.hour || 0)) / (nextMilestone.hour - (currentMilestone?.hour || 0))) * 100
    : 100;
  
  return (
    <div className="space-y-4">
      <h3 className="text-lg font-semibold text-fasttrack-blue">Current Stage</h3>
      
      <div className="p-3 rounded-lg bg-fasttrack-light-blue/20 mb-4 border border-fasttrack-light-blue/30">
        <h4 className="font-medium text-fasttrack-blue">
          {currentMilestone ? currentMilestone.title : "Getting Started"}
        </h4>
        <p className="text-sm text-muted-foreground mt-1">
          {currentMilestone ? currentMilestone.description : "Your body is preparing to enter a fasting state."}
        </p>
      </div>
      
      {nextMilestone && (
        <>
          <div className="flex justify-between items-center text-sm mb-1">
            <span>Progress to next stage</span>
            <span className="flex items-center gap-1 text-fasttrack-blue">
              <Clock size={14} />
              {nextMilestone.hour - elapsed > 0 
                ? `${Math.round((nextMilestone.hour - elapsed) * 10) / 10}h remaining` 
                : "Complete"}
            </span>
          </div>
          
          <Progress value={progressToNext} className="h-2 bg-fasttrack-light-blue/30 [&>div]:bg-fasttrack-blue" />
          
          <div className="p-3 rounded-lg border border-dashed mt-4 border-fasttrack-light-blue/50">
            <h4 className="font-medium text-muted-foreground">Coming up: {nextMilestone.title}</h4>
            <p className="text-xs text-muted-foreground mt-1">
              {nextMilestone.description}
            </p>
          </div>
        </>
      )}
    </div>
  );
};
